module.exports = __webpack_public_path__ + "static/img/zhaobiao.d172d086.png";